import { render, staticRenderFns } from "./BoletinRecipientsView.vue?vue&type=template&id=4521b44b&scoped=true&"
import script from "./BoletinRecipientsView.vue?vue&type=script&lang=js&"
export * from "./BoletinRecipientsView.vue?vue&type=script&lang=js&"
import style0 from "./BoletinRecipientsView.vue?vue&type=style&index=0&id=4521b44b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4521b44b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardTitle,
  VDivider,
  VFlex,
  VLayout,
  VList,
  VListTile,
  VListTileContent,
  VListTileTitle,
  VSubheader,
  VToolbar,
  VToolbarTitle,
})
